import request from '@/utils/request'

/**
 * 获取订单详情
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getOrderDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryAdminStoreOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取订单商品列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getOrderCarts(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryAdminStoreOrderCart',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取订单费用列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getOrderFees(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryAdminStoreOrderCartFee',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取订单分账列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getOrderLedgers(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderLedgerAcct.queryAdminOrderLedgerAcct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取订单地址列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getOrderAddress(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryAdminOrderAddress',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取订单操作信息列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getOrderEvents(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder/queryStoreOrderCartEvent',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取订单优惠信息列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getOrderDiscounts(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryAdminOrderDiscount',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}